var render, staticRenderFns
import script from "./sw-qsg-modal.vue?vue&type=script&lang=tsx&"
export * from "./sw-qsg-modal.vue?vue&type=script&lang=tsx&"
import style0 from "./sw-qsg-modal.vue?vue&type=style&index=0&id=285d5242&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285d5242",
  null
  
)

export default component.exports